import createReducer from 'utils/redux/createReducer'

const initialState = {}

let typeToSelect = {
    'transaction/bill': 'transaction',
    'transaction/invoice': 'transaction',
    'merchant': 'vendor',
    'project': 'project',
    'property': 'property',
    'lease': 'lease',
	'task': 'task'
}

export default createReducer(initialState, {
	CHOOSE_ITEM: (currentState, action) => ({...currentState, [action.data.type]:action.data.id })
  , ADD: (currentState, action) => ({...currentState, [typeToSelect[action.data.type] || action.data.type]:action._id })
})



// WEBPACK FOOTER //
// ./src/reducers/selectedRows.js